module.exports = __webpack_public_path__ + "img/image_refund.45f15db9.png";